export enum RootMenuEnum {
    Admin = 1,
    Partner = 2
}
